import React from 'react';

// 三个点跳动的加载组件 - 仿Ant Design X Bubble样式
const DotsLoading = ({ size = 'default' }) => {
    const dotStyle = {
        display: 'inline-block',
        width: '4px',
        height: '4px',
        borderRadius: '50%',
        backgroundColor: 'var(--color-grt-primary)',
        margin: '0 7px',
        animation: 'antd-bubble-dots 1.4s infinite ease-in-out both'
    };

    const containerStyle = {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1px 0'
    };

    // 定义CSS动画 - 仿Ant Design X样式
    React.useEffect(() => {
        const styleId = 'antd-bubble-dots-animation';
        if (!document.getElementById(styleId)) {
            const style = document.createElement('style');
            style.id = styleId;
            style.textContent = `
                @keyframes antd-bubble-dots {
                    0%, 80%, 100% {
                        transform: translateY(0);
                    }
                    40% {
                        transform: translateY(-6px);
                    }
                }
            `;
            document.head.appendChild(style);
        }
    }, []);

    return (
        <div style={containerStyle}>
            <span style={{ ...dotStyle, animationDelay: '0s' }}></span>
            <span style={{ ...dotStyle, animationDelay: '0.16s' }}></span>
            <span style={{ ...dotStyle, animationDelay: '0.32s' }}></span>
        </div>
    );
};

export default DotsLoading; 